import { map } from 'rxjs/operators';
import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { Logger } from '@app/core/logging';
import { ContentsService } from '@vestiaire/api-sdk-angular';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import * as HeaderActions from '@app/core/header/store/actions';
import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'vc-promotions-legal-conditions',
  templateUrl: './promotions-legal-conditions.component.html',
  styleUrls: ['./promotions-legal-conditions.component.scss']
})
export class PromotionsLegalConditionsComponent implements OnInit {
  public contentLegals = '';

  constructor(
    private contentsService: ContentsService,
    private logger: Logger,
    private store: Store<IAppState>,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.getLegals();
    }
    this.store.dispatch(new HeaderActions.SetPageParams(null));
  }

  getLegals() {
    this.contentsService
      .listPromotionalBanners()
      .pipe(map(res => res.data))
      .subscribe(
        res => {
          if (res.length > 0) {
            this.contentLegals = res[0].contentLegals;
          }
        },
        err => {
          this.logger.error('Promotions legal conditions not working', err);
        }
      );
  }
}
